import { BREAKPOINT_KEYS } from 'Context/BreakpointsContext/BreakpointsContext.const';
import type { Breakpoints } from 'Context/BreakpointsContext/BreakpointsContext.types';

export const isBreakpointKey = (key: unknown): key is keyof Breakpoints => {
	return BREAKPOINT_KEYS.includes(key as string);
};
